interface HourGlassIconProps {
  className?: string;
  width?: number;
  height?: number;
}
const HourGlassIcon: React.FC<HourGlassIconProps> = ({
  width = 7,
  height = 11,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 7 11"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.644645V1.28929L3.39982 1.28385L6.79965 1.27842V0.644645V0.0108708L3.39982 0.00543542L0 0V0.644645ZM0.687484 2.25203C0.687484 2.84691 0.700396 2.92797 0.823735 3.10792C0.876649 3.18511 1.21895 3.47115 2.15013 4.2163C2.8404 4.76867 3.41003 5.22062 3.41594 5.22065C3.42184 5.22067 3.99194 4.76871 4.6828 4.21632C5.62912 3.4597 5.95625 3.18629 6.00919 3.10792C6.13158 2.92668 6.14439 2.84562 6.14439 2.25203V1.71884H3.41594H0.687484V2.25203ZM2.23177 6.68424C1.58918 7.18195 1.01703 7.63393 0.960286 7.68861C0.903375 7.74345 0.826313 7.8504 0.788415 7.92714L0.71971 8.06625L0.712835 8.67371L0.705981 9.28116H3.44666H6.18736V8.7695C6.18736 8.10333 6.16142 7.96914 5.99082 7.75231C5.93112 7.67642 3.45854 5.77929 3.41933 5.77929C3.40874 5.77929 2.87433 6.18652 2.23177 6.68424ZM0 10.3554V11L3.39982 10.9946L6.79965 10.9891V10.3554V9.72158L3.39982 9.71615L0 9.71071V10.3554Z"
        fill="white"
      />
    </svg>
  );
};

export default HourGlassIcon;
